"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8 9.148a.7.7 0 0 1-.7-.7v-1.89a.7.7 0 1 1 1.4 0v1.89a.7.7 0 0 1-.7.7",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.254 10.487a.746.746 0 1 1 1.492 0 .746.746 0 0 1-1.492 0"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M6.101 3.671c.844-1.462 2.954-1.462 3.798 0l3.819 6.616c.805 1.395-.202 3.139-1.813 3.139h-7.81c-1.611 0-2.618-1.744-1.813-3.14zm2.585.7a.792.792 0 0 0-1.372 0l-3.82 6.615a.693.693 0 0 0 .6 1.04h7.811a.693.693 0 0 0 .6-1.04z",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=ErrorWarningTriangleOutlineIcon16.js.map